import { RoleModuleTabs } from '../../enums/permission-module.enum';

export const roleSettingInfoTabs = [
	{
		name: 'Permissions',
		path: `/role-settings/:id`,
		permissionId: RoleModuleTabs.Permissions,
	},
];
